import React from "react";
import classNames from "classnames";
import { resolveElitVehicleId } from "../elitVehicleSelection";
import { DEFAULT_ORDER_FORM_LOCALE } from "../orderFormLocale";
import { ORDER_VEHICLES } from "../vehicleData";
import { OrderFormLocale } from "../types";
import radioOff from "../../../static/ride-order/ic_check.svg";
import radioOn from "../../../static/ride-order/ic_checked.svg";
import styles from "./orderForm.module.scss";

type ElitVehicleSelectProps = {
  vehicleId: string;
  locale?: OrderFormLocale;
  isPanelOpen: boolean;
  onVehicleChange: (vehicleId: string) => void;
  onOpenPanel: () => void;
};

const ElitVehicleSelect: React.FC<ElitVehicleSelectProps> = ({
  vehicleId,
  locale,
  isPanelOpen,
  onVehicleChange,
  onOpenPanel,
}) => {
  const resolvedLocale = locale ?? DEFAULT_ORDER_FORM_LOCALE;
  const elitLabels = resolvedLocale.elit ?? DEFAULT_ORDER_FORM_LOCALE.elit;
  const selectedVehicleId = resolveElitVehicleId(vehicleId);

  return (
    <div className={styles.vehiclePickerWrap}>
      <span className={styles.vehiclePickerLabel}>{elitLabels?.vehicleLabel ?? "Vehicle"}</span>

      <div
        className={styles.vehiclePickerRow}
        role="radiogroup"
        aria-label={elitLabels?.vehicleLabel}
      >
        {ORDER_VEHICLES.map((vehicle) => {
          const isSelected = selectedVehicleId === vehicle.id;

          return (
            <button
              key={vehicle.id}
              type="button"
              className={classNames(styles.vehiclePickerCard, {
                [styles.vehiclePickerCardSelected]: isSelected,
              })}
              onClick={() => onVehicleChange(vehicle.id)}
              aria-checked={isSelected}
              role="radio"
            >
              <img
                className={styles.vehiclePickerRadio}
                src={isSelected ? radioOn : radioOff}
                alt=""
                aria-hidden
              />
              <span className={styles.vehiclePickerImageWrap}>
                <img className={styles.vehiclePickerImage} src={vehicle.image} alt={vehicle.name} />
              </span>
              <span className={styles.vehiclePickerTitle}>{vehicle.name}</span>
            </button>
          );
        })}
      </div>

      <button
        type="button"
        className={styles.elitMoreDetailsBtn}
        onClick={onOpenPanel}
        aria-haspopup="dialog"
        aria-expanded={isPanelOpen}
      >
        {elitLabels?.moreCarDetailsLabel ?? "More car details"}
      </button>
    </div>
  );
};

export default ElitVehicleSelect;
